import { push, ref } from "firebase/database";
import { database } from "../../../../Utils/firebase";
import GetExpenseDataFirebase from "../../Expense/GetExpenseDataFirebase";


const AddAssignerUserExpenseDataInFirebase = async (state, dispatch, expenseData, userId, ownerUid) => {
    if (!ownerUid) return null;





    try {

        // Reference to user's invoice data
        const userRef = ref(database, `invoiceGenerator/users/${ownerUid}/expense`);

        const data = {
            createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            createdById: state?.USERID || null,
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            updatedById: state?.USERID || null,
            companyId: expenseData?.companyId?.toString() || "",
            createdDate: new Date().getTime().toString(),
            amount: expenseData?.amount?.toString() || "",
            expenseCategory: (expenseData?.category || expenseData?.expenseCategory)?.toString() || "",
            expenseDate: expenseData?.expenseDate || new Date().toISOString().slice(0, 10), // Defaults to today
            expenseDescription: (expenseData?.description || expenseData?.expenseDescription)?.toString() || "",
            expenseId: expenseData?.expenseId?.toString() || "",
            paymentMethod: expenseData?.paymentMethod || "Cash",
            expenseName: expenseData?.expenseName || "",
            updateDate: expenseData?.updateDate?.toString() || new Date().getTime().toString(),
            platform: "website",
            version: process.env.REACT_APP_VERSION,
            currency: expenseData?.currency?.toString() || ""
        }

        // Push new invoice data
        await push(userRef, {
            createdBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            updatedBy: state?.SET_USER?.name || state?.SET_USER?.email || state?.SET_USER?.contact || "guest",
            companyId: expenseData?.companyId?.toString() || "",
            createdDate: new Date().getTime().toString(),
            amount: expenseData?.amount?.toString() || "",
            expenseCategory: (expenseData?.category || expenseData?.expenseCategory)?.toString() || "",
            expenseDate: expenseData?.expenseDate || new Date().toISOString().slice(0, 10), // Defaults to today
            expenseDescription: (expenseData?.description || expenseData?.expenseDescription)?.toString() || "",
            expenseId: expenseData?.expenseId?.toString() || "",
            paymentMethod: expenseData?.paymentMethod || "Cash",
            expenseName: expenseData?.expenseName || "",
            updateDate: expenseData?.updateDate?.toString() || new Date().getTime().toString(),
            isDeleted: false,
            currency: expenseData?.currency?.toString() || ""
        });
        await GetExpenseDataFirebase(state, dispatch);

        return { success: true, message: "New expense added successfully!" };
    } catch (error) {
        console.log("error", error);

        return { success: false, message: error };
    }
};

export default AddAssignerUserExpenseDataInFirebase;
